'use client';

import _slicedToArray from "/codebuild/output/src3176/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useRef, useEffect } from 'react';
import { useReducedMotion } from '@mantine/hooks';
function useLockScroll(_ref) {
  var opened = _ref.opened,
    transitionDuration = _ref.transitionDuration;
  var _useState = useState(opened),
    _useState2 = _slicedToArray(_useState, 2),
    shouldLockScroll = _useState2[0],
    setShouldLockScroll = _useState2[1];
  var timeout = useRef();
  var reduceMotion = useReducedMotion();
  var _transitionDuration = reduceMotion ? 0 : transitionDuration;
  useEffect(function () {
    if (opened) {
      setShouldLockScroll(true);
      window.clearTimeout(timeout.current);
    } else if (_transitionDuration === 0) {
      setShouldLockScroll(false);
    } else {
      timeout.current = window.setTimeout(function () {
        return setShouldLockScroll(false);
      }, _transitionDuration);
    }
    return function () {
      return window.clearTimeout(timeout.current);
    };
  }, [opened, _transitionDuration]);
  return shouldLockScroll;
}
export { useLockScroll };